<p-editor
  [(ngModel)]="editorContent"
  attr.iso2="{{ languageIso2 }}"
  [id]="id"
  [style]="{ height: '320px' }"
  (onTextChange)="handleTextChange($event)"
></p-editor>

<app-animated-logo *ngIf="isLoading == true"></app-animated-logo>
